/** The body a confirmation sends. The ticket is the one enrolment returned. */
export function mfaConfirmBody(
  email: string,
  code: string,
  ticket: string,
): { email: string; code: string; ticket: string } {
  if (ticket.trim() === '') throw new Error('The enrolment ticket is missing.');
  return { email, code, ticket };
}
